export default "__VITE_ASSET__edd2963a__"